import React, {ReactNode} from 'react';
import {LucideIcon} from 'lucide-react';

interface EmptyStateProps {
    icon?: LucideIcon;
    title: ReactNode;
    children?: ReactNode;
    action?: ReactNode;
    className?: string;
}

/** A centred, muted block for empty lists and not-yet-built sections. */
const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    children,
    action,
    className
}) => (
    <div className={`ft-empty ${className ?? ''}`}>
        {Icon && (
            <div className="ft-empty__icon">
                <Icon size={32} strokeWidth={1.5} />
            </div>
        )}
        <h5 className="ft-empty__title">{title}</h5>
        {children && <div className="ft-empty__body">{children}</div>}
        {action && <div className="mt-3">{action}</div>}
    </div>
);

export default EmptyState;
